import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_VEHICLE_URL;

//#region Model

// GET request
export function GetModels(
  clientId: string,
  queryParams?: any
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}clients/${clientId}/models`,
    "GET",
    queryParams
  );
}

// GET request
export function GetModelById(customerId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}Models/${customerId}`, "GET");
}

// POST request
export function AddModel(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}models`, "POST", body);
}

// PUT request
export function UpdateModel(
  customerId: string,
  body?: any
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}Models/${customerId}`, "PUT", body);
}

// DELETE request
export function DeleteModel(modelId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}models/${modelId}`, "DELETE");
}

// PATCH request
export function PatchModel(modelId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}models/${modelId}`, "PATCH");
}

//#endregion Model
